<button nbButton
        status="primary"
        nbTooltip="Link kopieren"
        [disabled]="disabled()"
        (click)="copyToClipboard()">
  <nb-icon *ngIf="!copiedToClipboard()" pack="eva" icon="copy-outline"></nb-icon>
  <nb-icon *ngIf="copiedToClipboard()" pack="eva" icon="checkmark-outline"></nb-icon>
</button>
